import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-input-edit',
  templateUrl: './input-edit.component.html',
  styleUrls: ['./input-edit.component.scss']
})
export class InputEditComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
